import { Icon, type IconTone } from './Icon';

/** Отклонено. */
export function CrossIcon({ size, tone }: { size?: number; tone?: IconTone }) {
  return (
    <Icon size={size} box={12} tone={tone}>
      <path d="M2.4 2.4 L9.6 9.6" strokeWidth={1.4} />
      <path d="M9.6 2.4 L2.4 9.6" strokeWidth={1.4} />
    </Icon>
  );
}
